import { useState } from 'react'
import { Form, Button, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useLoginUserMutation } from '../../app/authApiSlice'
import LoadingTextSwap from '../../components/LoadingTextSwap'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loginUser, { isLoading, isError }] = useLoginUserMutation()

  const onEmailChange = e => setEmail(e.target.value)
  const onPasswordChange = e => setPassword(e.target.value)

  const handleLogin = e => {
    e.preventDefault()
    loginUser({ email, password })
  }

  return (
    <>
      <Card className="w-100 border-0 shadow" style={{ maxWidth: '400px' }}>
        <Card.Body>
          <h2 className="text-center mb-4">Log in</h2>
          <Form onSubmit={handleLogin}>
            <Form.Group id="email" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" value={email} onChange={onEmailChange} required></Form.Control>
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" value={password} onChange={onPasswordChange} required />
            </Form.Group>
            {isError && <p className="text-danger fs-8 mt-2 mb-0 i fw-semibold">Login details are incorrect</p>}
            <Button disabled={isLoading} className="w-100 mt-4" type="submit">
              <LoadingTextSwap isLoading={isLoading}>Log in</LoadingTextSwap>
            </Button>
          </Form>
          <div className="w-100 text-center mt-3">
            <Link to="/login/forgot-password">Forgot Password?</Link>
          </div>
        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2">
        Need an account? <Link to="/login/create-account">Create Account</Link>
      </div>
    </>
  )
}
export default Login
